import { defineComponent as i, ref as f, openBlock as c, createBlock as m, unref as b, mergeProps as p, withCtx as y, renderSlot as v, nextTick as h } from "vue";
import D from "./ghl-ui.es293.js";
const k = i({
  name: "UIDatepicker"
}), B = i({
  ...k,
  props: {
    type: {
      type: String,
      default: "date"
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    panel: {
      type: Boolean,
      default: !1
    },
    isDateDisabled: {
      type: Function
    },
    isTimeDisabled: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      required: !0
    },
    shortcuts: {
      type: Object,
      default: void 0
    },
    value: {
      type: [Number, Array]
    },
    defaultValue: {
      type: [Number, Array]
    },
    format: {
      type: String
    },
    show: {
      type: Boolean,
      default: void 0
    },
    autoCompleteOff: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["confirm", "update:value"],
  setup(e, { emit: o }) {
    const l = e, d = o, u = f(null), n = (t) => {
      d("confirm", t);
    }, s = (t) => {
      t && l.autoCompleteOff && h(() => {
        const a = document.querySelector(`#${l.id} .n-input input`);
        a && a.setAttribute("autocomplete", "off");
      });
    };
    return (t, a) => (c(), m(b(D), p({ id: e.id }, t.$attrs, {
      disabled: e.disabled,
      "is-date-disabled": e.isDateDisabled,
      "is-time-disabled": e.isTimeDisabled,
      panel: e.panel,
      value: e.value,
      "default-value": e.defaultValue,
      clearable: e.clearable,
      type: e.type,
      size: "large",
      shortcuts: e.shortcuts,
      format: e.format,
      onConfirm: n,
      "onUpdate:value": a[0] || (a[0] = (r) => t.$emit("update:value", r)),
      onUpdateShow: s,
      ref: u.value,
      show: e.show
    }), {
      default: y(() => [
        v(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "is-date-disabled", "is-time-disabled", "panel", "value", "default-value", "clearable", "type", "shortcuts", "format", "show"]));
  }
}), S = B;
export {
  S as default
};
